import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-no-order',
  templateUrl: './no-order.component.html',
  styleUrls: ['./no-order.component.css']
})
export class NoOrderComponent implements OnInit {
  @Input() filterApplied = false;
  @Input() orderList = [];
  @Input() loaded = false;

  constructor() {
  }

  ngOnInit() {
  }
}
